import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static get targets() {
    return ["menu", "btn"];
  }

  connect() {
    useClickOutside(this);
  }

  clickOutside(event) {
    this.closeMenu();
  }

  toggleMenu() {
    if (this.btnTarget.getAttribute("aria-expanded") === "true") {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.menuTarget.classList.remove("tdd-none");
    this.btnTarget.setAttribute("aria-expanded", "true");
  }

  closeMenu() {
    this.menuTarget.classList.add("tdd-none");
    this.btnTarget.setAttribute("aria-expanded", "false");
  }
}
